/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useEffect, useState } from 'react';

export const CookiesContext = createContext({});
export const CookiesProvider = ({children}) => {
  const [ cookiesAllowed, setCookiesAllowed ] = useState(false);

  useEffect(() => {
    let mounted = true;
    if ( mounted ) {
      setCookiesAllowed ( localStorage.getItem(process.env.REACT_APP_ACCEPT_COOKIES) || false );
    }
    return () => mounted = false;
  }, []);

  return (
    <CookiesContext.Provider
      value={{
        cookiesAllowed,
        setCookiesAllowed
      }}
    >
      {children}
    </CookiesContext.Provider>
  )
}

export const useCookies = () => useContext(CookiesContext);